import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PartialProfile } from './../models/partialProfile';
import { PortalApiService } from './../../../shared/services/api/portal-api.service';

const apiEndpoints = {
  partialProfile:'practitioneranon/{GUID}/partialProfile'
};

@Injectable()
export class PartialProfileService {

  constructor(private portalApiService: PortalApiService) { }

  getProfile(id: string): Observable<any>{    
    return this.portalApiService.get(apiEndpoints.partialProfile.replace("{GUID}",id));     
  }

  updateProfile(id:string, profileData:PartialProfile):Observable<any> {
    return this.portalApiService.post(apiEndpoints.partialProfile.replace('{GUID}',id), profileData);
  }    
}
